import { AxiosResponse } from 'axios';
import {
  RegistrationMarriageFormVM,
  SearchMarriageFormVM,
  AccordionMarriage,
} from 'mutation/view-models/registration-marriage';
import { ActCategory } from 'shell/models/act-category-list';
import { HttpResponse } from 'shell/models/http-response';
import { transformEditDataControl } from './transform-edit-data-control';
import { transformMarriageAccordion } from './transform-marriage-accordion';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';
import { checkError, formatErrorMunicipalityForeign } from '../transform-family-detail/check-error';

export const transformMarriage = (
  response: AxiosResponse<HttpResponse<ActCategory>>,
  isMaritoResidenceMilano?: boolean
): { data: RegistrationMarriageFormVM; error?: string } => {
  const castedRes = response.data.payload.consultazioneANSCResponse?.modelEventoDTO || [];
  const modelEventoDTO = castedRes[0] || {};

  const castedDatiAggiuntiviSide = response.data.payload.datiAggiuntiviSide || {};
  const intestatari = castedDatiAggiuntiviSide.intestatariTranscod || [];

  const editDataControl = transformEditDataControl(modelEventoDTO);
  const marriageAnsSearch: { marriage?: AccordionMarriage; searchMarriage?: SearchMarriageFormVM } =
    transformMarriageAccordion(
      isMaritoResidenceMilano ? intestatari[1] : intestatari[0],
      modelEventoDTO,
      castedDatiAggiuntiviSide
    );

  const errorIntestatario1: string = checkError(intestatari[0]);
  const errorIntestatario2: string = checkError(intestatari[1]);

  let errorMarriage;

  const isForeign =
    castedDatiAggiuntiviSide?.luogoCelebrazioneTranscod &&
    castedDatiAggiuntiviSide?.luogoCelebrazioneTranscod.idStato !== CODE_STATE_ITALIAN;

  if (isForeign && !castedDatiAggiuntiviSide.luogoCelebrazioneTranscod?.idComune) {
    errorMarriage = formatErrorMunicipalityForeign(
      castedDatiAggiuntiviSide.luogoCelebrazioneTranscod?.comuneEstero,
      castedDatiAggiuntiviSide.luogoCelebrazioneTranscod?.nomeStato
    );
  }

  return {
    data: {
      editDataControl,
      marriage: marriageAnsSearch.marriage,
      searchMarriage: marriageAnsSearch.searchMarriage,
    },
    error: errorIntestatario1 || errorIntestatario2 || errorMarriage,
  };
};
